export default __webpack_public_path__ + "static/media/corporate23.b5791d5f.svg";